import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, firstValueFrom } from 'rxjs';
import { ErrorFrontend } from '@core/errors';
import type { Contract, PaginatedResponse, PaginationParams } from '@core/models';

/**
 * Contract Service
 * Manages EPS/Insurance contracts
 */
@Injectable({
  providedIn: 'root',
})
export class ContractService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = 'orgs/contracts';

  /**
   * List all active contracts
   * Backend automatically filters by user's branch/organization
   */
  async list(params?: PaginationParams): Promise<PaginatedResponse<Contract>> {
    return await firstValueFrom(
      this.http
        .get<PaginatedResponse<Contract>>(`${this.baseUrl}/`, {
          params: params as Record<string, string | number>,
        })
        .pipe(
          catchError((error: HttpErrorResponse) => {
            throw new ErrorFrontend(error);
          }),
        ),
    );
  }
}
